import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_beauty_new_products: FaireCategoryEntity = {
  token: "cat_beauty-new-products",
  type: "category",
  name: "New products",
  level: 2,
  parentToken: "cat_beauty-wellness",
  href: "/category/beauty-wellness/new-products",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
